import ajax from '../Common/API/ajax'
// import storage from 'Common/API/Storage'
// import device from 'Common/API/Device'
import util from '../Common/API/util'
// import wx from 'Common/API/WX'
// import googleMap from 'Common/API/GoogleMap'
import _aspect from '../Common/API/iView'
const noParams={}
export default {
    util,
    admin: {
        signIn(params) {
            return ajax.post('/admin/signIn', params)
        },
        sync() {
            return ajax.get('/admin/sync')
        },
        signOut() {
            return ajax.delete('/admin/signOut')
        },
    },
    goods: {
        searchPage(condition, page) {
            return ajax.post('/goods/searchPage',{ condition, page })
        },
        create(params) {
            return ajax.post('/goods/create', params)
        },
        delete(id) {
          return ajax.delete('/goods/' + id)
        },
        update(params) {
            return ajax.post('/goods/update', params)
        },
        searchGoodsGallery(params) {
            return ajax.post('/goods/searchGoodsGallery', params)
        },
        updateGoodsGallery(params) {
          return ajax.post('/goods/updateGoodsGallery', params)
        }
    },
    category: {
        search(condition) {
            return ajax.post('/category/search', { condition })
        },
        searchPage(condition, page) {
            return ajax.post('/category/searchPage', { condition, page })
        },
        create(params) {
            return ajax.post('/category/create', params)
        },
        update(params) {
          return ajax.post('/category/update', params)
        },
        delete(id) {
          return ajax.delete('/category/delete/' + id)
        },
    },
    file: {
        imageUpload() {
            return ajax.post('/file/imageUpload')
        }
    },
    search: {
        searchPageKeyWords(condition, page) {
            return ajax.post('/search/searchPageKeyWords',{ condition, page })
        },
        deleteKeyWord(id) {
            return ajax.delete('/search/deleteKeyWord/' + id)
        },
        createKeyWord(params) {
          return ajax.post('/search/createKeyWord', params)
        },
        updateKeyWord(params) {
          return ajax.post('/search/updateKeyWord', params)
        }
    },
    banner: {
        searchPage(condition, page) {
            return ajax.post('/banner/searchPage', { condition, page })
        },
        create(params) {
          return ajax.post('/banner/create', params)
        },
        update(params) {
          return ajax.post('/banner/update', params)
        },
        delete(id) {
          return ajax.delete('/banner/delete/' + id)
        },
    },
    order: {
      searchOrderPage(payed, condition, page) {
        return ajax.post('/order/searchOrderPage', { payed, condition, page })
      },
      addOrderExpressId(params) {
        return ajax.post('/order/addOrderExpressId', params)
      },
      queryCurrentExpress(params) {
        return ajax.post('/order/queryCurrentExpress', params)
      },
      searchExpressCompany() {
        return ajax.get('/order/searchExpressCompany')
      }
    },
    topic: {
        searchPage(condition, page) {
            return ajax.post('/topic/searchPage', { condition, page })
        },
        create(params) {
          return ajax.post('/topic/create', params)
        },
        update(params) {
          return ajax.post('/topic/update', params)
        },
        delete(id) {
          return ajax.delete('/topic/delete/' + id)
        },
    },
    brand: {
        searchPage(condition, page) {
            return ajax.post('/brand/searchPage', { condition, page })
        },
        search(condition) {
            return ajax.post('/brand/search', { condition })
        },
        create(params) {
          return ajax.post('/brand/create', params)
        },
        update(params) {
          return ajax.post('/brand/update', params)
        },
        delete(id) {
          return ajax.delete('/brand/delete/' + id)
        },
    },
    channel: {
        searchPage(condition, page) {
            return ajax.post('/channel/searchPage',{ condition, page })
        },
        create(params) {
          return ajax.post('/channel/create', params)
        },
        update(params) {
          return ajax.post('/channel/update', params)
        },
        delete(id) {
          return ajax.delete('/channel/delete/' + id)
        },
    },
    feedback: {
        searchPage(condition, page) {
            return ajax.post('/feedback/searchPage', { condition, page })
        },
    }
}



// WEBPACK FOOTER //
// ./src/API/index.js